import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function footer(element: HTMLElement) {
  // const footerInner = element.querySelector('.js-footer-inner')
  let trigger: GSAPTween | null = null
  let mm = gsap.matchMedia()
  const parentSection = element.previousElementSibling

  function init() {
    mm.add('(min-width: 768px)', () => {
      trigger = gsap.fromTo(
        element,
        {
          yPercent: '-100'
        },
        {
          yPercent: 0,
          ease: 'linear',
          scrollTrigger: {
            trigger: parentSection,
            start: `top center`,
            end: `center center`,
            //markers: true,
            scrub: true
          }
        }
      )
    })
  }

  init()

  function destroy() {
    if (trigger && trigger.scrollTrigger) {
      trigger.scrollTrigger.kill() // Kill the ScrollTrigger
      trigger = null
    }
    gsap.set(element, { clearProps: 'all' }) // Clear gsap properties
    mm.revert()
  }

  return {
    init,
    destroy
  }
}
